import { OnboardingProgressStep, PeriodicReviewProgressStep } from '@/context/progress';
import { useIsPeriodicReview } from '@/features/periodic-review/context';

export const usePersonalInformationProgressStep = () =>
  useIsPeriodicReview() ? PeriodicReviewProgressStep.PERIODIC_REVIEW_PERSONAL_INFORMATION : OnboardingProgressStep.PERSONAL_INFORMATION;
